import { StorageCheckoutData } from '../data';

type Key = keyof StorageCheckoutData;
const TRANSIENT_PROPERTY_KEYS: Key[] = [
  'leadToken',
  'zipValidated',
  'checkoutType',
  'customerToken',
];

// Sometimes we store a property for client side persistence but don't want to persist on the server (e.g. tokens, complex objects)
function removeTransientProperties(data: PartialRecord<Key, any>) {
  for (const key of TRANSIENT_PROPERTY_KEYS) {
    if (key in data) delete data[key];
  }
  return data;
}

export const transformStorageStepTransitionData = (
  data: StorageCheckoutData,
) => {
  const transformed: Record<string, any> & Partial<StorageCheckoutData> = {
    ...data,
  };

  removeTransientProperties(transformed);

  return transformed;
};
